import FadeInWrapper from './fade-in-wrapper';

export default FadeInWrapper;
